module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-L-43.6c7b1b9d.png";